const currencies = {
  EUR: '€',
  CHF: ' CHF',
  SFR: ' SFr.',
  GBP: '£',
  USD: '$',
};

export default currencies;
